export const TEXTS = {
  ABOUT: (name: string) => `About ${name}`,
};
